module.exports = __webpack_public_path__ + "img/products.bcfddbc5.png";